export class NavigateEvent extends CustomEvent {
    constructor(path) {
        super(NavigateEvent.eventName, { bubbles: true, composed: true, detail: path });
    }
}
NavigateEvent.eventName = 'navigate';
//# sourceMappingURL=events.js.map